module.exports = __webpack_public_path__ + "media/images/icons/consultation-04-752d3d9b770d05312d427d7d990c74d1.svg";